import React from "react";
import {withTranslation} from "react-i18next";
import stylesWelcome from "../SchedaSpecialeMIB.module.css"
import Utils from "../../../../../../../utils/Utils";

import Input from "../../../../../../../components/textbox/Input";
import RadioButton from "../../../../../../../components/radiobutton/RadioButton";


class AgenteEziologicoMIB extends React.Component {

    state = {
        agenteEziologico: {
            malattiaBatterica: this.props.statePadre && this.props.statePadre.malattiaBatterica ? this.props.statePadre.malattiaBatterica : "",
            meningite: this.props.statePadre && this.props.statePadre.meningite ? this.props.statePadre.meningite : "",
            meningiteAltro: this.props.statePadre && this.props.statePadre.meningiteAltro ? this.props.statePadre.meningiteAltro : "",
            corretto: []
        }
    }

    constructor(props) {
        super(props)

        this.riceviValore = this.riceviValore.bind(this);
        this.riceviValoreRadioButton = this.riceviValoreRadioButton.bind(this);
        this.createOggettoBE = this.createOggettoBE.bind(this);
        this.controlloDatiAgente = this.controlloDatiAgente.bind(this);
    }

    componentDidMount() {

        if (this.props.segnalazioneCopia.schedaSpeciale && this.props.segnalazioneCopia.schedaSpeciale.agenteEziologicoMIB) {
            let agenteEziologico = this.state.agenteEziologico
            let agenteEziologicoProps = this.props.segnalazioneCopia.schedaSpeciale.agenteEziologicoMIB

            agenteEziologico.malattiaBatterica = this.props.statePadre && this.props.statePadre.malattiaBatterica ? this.props.statePadre.malattiaBatterica : agenteEziologicoProps.malattiaBatterica ? agenteEziologicoProps.malattiaBatterica : this.state.agenteEziologico.malattiaBatterica
            agenteEziologico.meningite = this.props.statePadre && this.props.statePadre.meningite ? this.props.statePadre.meningite : agenteEziologicoProps.meningite ? agenteEziologicoProps.meningite : this.state.agenteEziologico.meningite
            agenteEziologico.meningiteAltro = this.props.statePadre && this.props.statePadre.meningiteAltro ? this.props.statePadre.meningiteAltro : agenteEziologicoProps.meningiteAltro ? agenteEziologicoProps.meningiteAltro : this.state.agenteEziologico.meningiteAltro

            this.setState({agenteEziologico: agenteEziologico});

        }

        this.controlloDatiAgente()
        let oggetto = this.createOggettoBE()
        this.props.setAgenteEziologicoMIB(this.state.agenteEziologico, oggetto)

    }

    controlloDatiAgente() {
        let agente = this.state.agenteEziologico
        agente.corretto = []

        if(!this.state.agenteEziologico.malattiaBatterica) agente.corretto[0] = "Campo \"Agente Eziologico per Malattia Batterica Invasiva\" mancante";
        else if(this.state.agenteEziologico.malattiaBatterica === "malattiaBatterica4" && !agente.meningite) agente.corretto[0] = "Campo \"Altro agente eziologico causante meningite batterica\" mancante";
        else if(this.state.agenteEziologico.malattiaBatterica === "malattiaBatterica4" && agente.meningite === "meningite4" && !this.state.agenteEziologico.meningiteAltro) agente.corretto[0] = "Campo \"Altro agente batterico\" mancante";

        this.setState({agente: agente})
    }

    createOggettoBE() {
        let agenteEziologico = JSON.parse(JSON.stringify(this.state.agenteEziologico))
        let agenteEziologicoBe = Utils.removeEmptyValueFromObject(agenteEziologico)
        return Utils.removeFieldFromObject(agenteEziologicoBe, "corretto")

    }

    riceviValore(field, event) {
        let agenteEziologico = this.state.agenteEziologico
        agenteEziologico[field] = event.target.value
        this.setState({agenteEziologico: agenteEziologico})

        this.controlloDatiAgente()
        let oggetto = this.createOggettoBE()
        this.props.setAgenteEziologicoMIB(this.state.agenteEziologico, oggetto)
    }

    riceviValoreRadioButton(event, field) {
        let agenteEziologico = this.state.agenteEziologico
        agenteEziologico[field] = event
        if (event !== "meningite4" && field === "meningite") {
            agenteEziologico.meningiteAltro = "";
        }

        if (event !== "malattiaBatterica4" && field === "malattiaBatterica") {
            agenteEziologico.meningite = "";
            agenteEziologico.meningiteAltro = "";
        }

        this.setState({agenteEziologico: agenteEziologico})

        this.controlloDatiAgente()
        let oggetto = this.createOggettoBE()
        this.props.setAgenteEziologicoMIB(this.state.agenteEziologico, oggetto)
    }

    render() {

        const {t} = this.props;

        const sezione1 = (
            <div>
                <div>
                    <h6>{t("SchedaFlussoSpeciale.MIB.AgenteEziomologico.titolo")}<span
                        className={stylesWelcome.mandatoryColor}>*</span></h6>
                    <hr className={stylesWelcome.hr}></hr>
                </div>
                <div className="container">
                    <div className="row">
                        <div className="col-lg-3">
                                    <RadioButton id={"malattiaBatterica1"}
                                                 name={"malattiaBatterica"}
                                                 style={{color: "black", fontSize: "16px"}}
                                                 label={t("SchedaFlussoSpeciale.MIB.AgenteEziomologico.neisseria")}
                                                 value={"1"}
                                                 onClick={() => this.riceviValoreRadioButton("malattiaBatterica1", "malattiaBatterica")}
                                                 checked={this.state.agenteEziologico.malattiaBatterica === "malattiaBatterica1"}
                                    ></RadioButton>
                        </div>
                        <div className="col-lg-3">
                                    <RadioButton id={"malattiaBatterica2"}
                                                 name={"malattiaBatterica"}
                                                 style={{color: "black", fontSize: "16px"}}
                                                 label={t("SchedaFlussoSpeciale.MIB.AgenteEziomologico.strepto")}
                                                 value={"2"}
                                                 onClick={() => this.riceviValoreRadioButton("malattiaBatterica2", "malattiaBatterica")}
                                                 checked={this.state.agenteEziologico.malattiaBatterica === "malattiaBatterica2"}
                                    ></RadioButton>
                                </div>
                                <div className="col-lg-3">
                                    <RadioButton id={"malattiaBatterica3"}
                                                 name={"malattiaBatterica"}
                                                 style={{color: "black", fontSize: "16px"}}
                                                 label={t("SchedaFlussoSpeciale.MIB.AgenteEziomologico.influenza")}
                                                 value={"3"}
                                                 onClick={() => this.riceviValoreRadioButton("malattiaBatterica3", "malattiaBatterica")}
                                                 checked={this.state.agenteEziologico.malattiaBatterica === "malattiaBatterica3"}
                                    ></RadioButton>
                                </div>
                                <div className="col-lg-3">
                                    <RadioButton id={"malattiaBatterica4"}
                                                 name={"malattiaBatterica"}
                                                 style={{color: "black", fontSize: "16px"}}
                                                 label={t("SchedaFlussoSpeciale.MIB.AgenteEziomologico.Altro.titolo")}
                                                 value={"4"}
                                                 onClick={() => this.riceviValoreRadioButton("malattiaBatterica4", "malattiaBatterica")}
                                                 checked={this.state.agenteEziologico.malattiaBatterica === "malattiaBatterica4"}
                                    ></RadioButton>
                                </div>
                        </div>
                    </div>
            </div>
        );


        const sezione2 = (
            <div>
                <div className="container">
                    <div className="row">
                        <div className="col-lg-9">
                            <p style={{marginTop: "10px"}}>
                                {t("SchedaFlussoSpeciale.MIB.AgenteEziomologico.Altro.titolo")}
                                {this.state.agenteEziologico.malattiaBatterica === "malattiaBatterica4" ?
                                    <span className={stylesWelcome.mandatoryColor}>*</span> : ""}

                            </p>

                            <RadioButton id={"meningite1"}
                                         name={"meningite"}
                                         style={{color: "black", fontSize: "16px"}}
                                         label={t("SchedaFlussoSpeciale.MIB.AgenteEziomologico.Altro.1")}
                                         value={"1"}
                                         onClick={() => this.riceviValoreRadioButton("meningite1", "meningite")}
                                         checked={this.state.agenteEziologico.meningite === "meningite1"}
                            ></RadioButton>
                            <RadioButton id={"meningite2"}
                                         name={"meningite"}
                                         style={{color: "black", fontSize: "16px"}}
                                         label={t("SchedaFlussoSpeciale.MIB.AgenteEziomologico.Altro.2")}
                                         value={"2"}
                                         onClick={() => this.riceviValoreRadioButton("meningite2", "meningite")}
                                         checked={this.state.agenteEziologico.meningite === "meningite2"}
                            ></RadioButton>
                            <RadioButton id={"meningite3"}
                                         name={"meningite"}
                                         style={{color: "black", fontSize: "16px"}}
                                         label={t("SchedaFlussoSpeciale.MIB.AgenteEziomologico.Altro.3")}
                                         value={"3"}
                                         onClick={() => this.riceviValoreRadioButton("meningite3", "meningite")}
                                         checked={this.state.agenteEziologico.meningite === "meningite3"}
                            ></RadioButton>
                            <div className="row">
                                <div className={"col-lg-3"}>
                                    <RadioButton id={"meningite4"}
                                                 name={"meningite"}
                                                 style={{color: "black", fontSize: "16px"}}
                                                 label={t("SchedaFlussoSpeciale.MIB.AgenteEziomologico.Altro.4")}
                                                 value={"4"}
                                                 onClick={() => this.riceviValoreRadioButton("meningite4", "meningite")}
                                                 checked={this.state.agenteEziologico.meningite === "meningite4"}
                                    ></RadioButton>
                                </div>
                                <div className={"col-lg-3"}>
                                    <Input id={"meningiteAltro"}
                                           style={{height: "2rem", marginTop: "10px"}}
                                           onChange={this.riceviValore}
                                           field={"meningiteAltro"}
                                           value={this.state.agenteEziologico.meningiteAltro}
                                           placeholder={t("SchedaFlussoSpeciale.MIB.AgenteEziomologico.Altro.4")}
                                           required={this.state.agenteEziologico.meningite === "meningite4"}
                                           disabled={this.state.agenteEziologico.meningite != "meningite4"}></Input>
                                </div>
                            </div>
                            <div style={{marginTop: "-10px"}}>
                                <RadioButton id={"meningite5"}
                                             name={"meningite"}
                                             style={{color: "black", fontSize: "16px"}}
                                             label={t("SchedaFlussoSpeciale.MIB.AgenteEziomologico.Altro.5")}
                                             value={"5"}
                                             onClick={() => this.riceviValoreRadioButton("meningite5", "meningite")}
                                             checked={this.state.agenteEziologico.meningite === "meningite5"}
                                ></RadioButton>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );

        return (
            <div>
                <fieldset
                    disabled={this.props.segnalazioneCopia && this.props.segnalazioneCopia.schedaSpeciale && this.props.segnalazioneCopia.schedaSpeciale.confermaSchedaUtenteLabMIB}>{sezione1}</fieldset>
                <fieldset
                    disabled={this.state.agenteEziologico.malattiaBatterica != "malattiaBatterica4"}>{sezione2}</fieldset>
            </div>

        )
    }

}

export default withTranslation('common')(AgenteEziologicoMIB)
